export enum ImportSourceType {
  DATABASE = "DATABASE",
  OTHER_SOURCE = "OTHER_SOURCE",
  HAND_SEARCH = "HAND_SEARCH",
  CITATION_SEARCH = "CITATION_SEARCH",
  FIELD_SAFETY_NOTICES = "FIELD_SAFETY_NOTICES",
  SEARCH_ENGINE = "SEARCH_ENGINE",
}
